module.exports = __webpack_public_path__ + "static/prozis.bf1c57aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/prozis.svg
// module id = 729
// module chunks = 213534597649335